import React from 'react';
import { cn } from '../lib/utils';

const Eyebrow = ({ children, className }) => (
  <p
    className={cn(
      "mb-4 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wide text-primary-light before:h-px before:w-6 before:bg-primary-light before:content-['']",
      className
    )}
  >
    {children}
  </p>
);

export default Eyebrow;
